var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueJsDatepicker',{attrs:{"language":_vm.lang,"inline":true,"value":_vm.date,"mondayFirst":true,"disabled-dates":_vm.disabledDates},on:{"selected":_vm.setDate,"changedMonth":_vm.changeMonth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }